//#region src/tracking-code-input/validation/catalog.ts
var e = {
	"html.unexpected-character-in-attribute-name": "Invalid character in attribute name.",
	"html.unexpected-character-in-unquoted-attribute-value": "Unexpected character after attribute value.",
	"html.unexpected-solidus-in-tag": "Unexpected character after / in tag. Expected >.",
	"html.missing-attribute-value": "Missing attribute value.",
	"html.duplicate-attribute": "Duplicate attribute.",
	"html.eof-in-tag": "Unexpected end of file in tag.",
	"html.end-tag-without-matching-open-element": "End tag without matching open element.",
	"html.missing-whitespace-between-attributes": "Missing whitespace between attributes.",
	"html.unexpected-equals-sign-before-attribute-name": "Unexpected equals sign before attribute name.",
	"html.invalid-first-character-of-tag-name": "Invalid first character of tag name.",
	"html.abrupt-closing-of-empty-comment": "Abrupt closing of empty comment.",
	"html.parse": "Invalid HTML markup.",
	"css.parse": "Invalid CSS syntax.",
	"js.syntax": "Invalid JavaScript syntax.",
	"html.empty-src": "Empty src attribute — the iframe has no source URL. Make sure this is intentional."
}, t = "Invalid code.", n = "The code is not valid.", r = /* @__PURE__ */ new Set([
	"missing-doctype",
	"missing-doctype-name",
	"misplaced-doctype",
	"non-conforming-doctype",
	"abrupt-doctype-public-identifier",
	"abrupt-doctype-system-identifier",
	"missing-doctype-public-identifier",
	"missing-doctype-system-identifier",
	"missing-quote-before-doctype-public-identifier",
	"missing-quote-before-doctype-system-identifier",
	"missing-whitespace-after-doctype-public-keyword",
	"missing-whitespace-after-doctype-system-keyword",
	"missing-whitespace-before-doctype-name",
	"missing-whitespace-between-doctype-public-and-system-identifiers",
	"invalid-character-sequence-after-doctype-name",
	"unexpected-character-after-doctype-system-identifier",
	"eof-in-doctype",
	"abandoned-head-element-child",
	"misplaced-start-tag-for-head-element",
	"nested-noscript-in-head",
	"disallowed-content-in-noscript-in-head"
]);
function i(t) {
	return e[t] ?? "Invalid code.";
}
var a = "public_pages_purchase.tracking_code_input", o = `${a}.field_error`, s = `${a}.invalid`;
function c(t) {
	return t in e ? `${a}.${t}` : s;
}
function l(t, n) {
	if (t.code === void 0 || !(t.code in e)) return t;
	let r = i(t.code);
	return t.message === r ? {
		...t,
		message: n(c(t.code), { defaultValue: r })
	} : t;
}
function u(e, t) {
	return e.map((e) => l(e, t));
}
function d(t) {
	if (r.has(t)) return null;
	let n = `html.${t}`;
	return n in e && n !== "html.parse" ? n : "html.parse";
}
//#endregion
export { e as BUILTIN_MESSAGE_CATALOG, a as CATALOG_LOCO_KEY_PREFIX, n as DEFAULT_FIELD_ERROR_MESSAGE, t as DEFAULT_INVALID_MESSAGE, o as FIELD_ERROR_LOCO_KEY, s as INVALID_LOCO_KEY, r as SILENCED_PARSE5_CODES, c as getCatalogLocoKey, l as localizeDiagnostic, u as localizeDiagnostics, d as mapParse5CodeToDiagnosticCode, i as resolveCatalogMessage };
